<template>
  <div v-if="!networkError">
    <LoaderImg v-if="!githubData" />
    <div
      v-if="githubData"
      class="github-user--content"
    >
      <img
        class="github-user--avatar"
        :src="avatarUrl"
        :alt="githubData.name"
      >
      <div class="github-user--data">
        <h3 class="name">
          {{ githubData.name }}
        </h3>
        <a
          class="html-url"
          :href="githubData.html_url"
        >{{ githubData.login }}</a>
        <p>
          Public Repositories <strong>{{ githubData.public_repos }}</strong><br>
          Followers <strong>{{ githubData.followers }}</strong>
        </p>
        <div>
          <a
            class="button"
            :href="githubData.html_url"
            target="_blank"
          >
            View on Github&nbsp;→
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import LoaderImg from '../components/LoaderImg.vue'

  export default {
    name: 'GithubUser',
    components: {
      LoaderImg,
    },
    data: () => ({
      githubData: null,
      networkError: false,
    }),
    computed: {
      // GitHub serves 460px by default; s= sizes it for the 4em (64px) display, 2x.
      avatarUrl() {
        const url = new URL(this.githubData.avatar_url)
        url.searchParams.set('s', '128')
        return url.href
      },
    },
    mounted() {
      this.getGithubData()
    },
    methods: {
      async getGithubData() {
        try {
          const res = await fetch('https://api.github.com/users/digitaldonkey')
          if (!res.ok) {
            throw new Error(`GitHub request failed: ${res.status}`)
          }
          this.githubData = await res.json()
        }
        catch (e) {
          this.networkError = true
          throw e
        }
      },
    },
  }
</script>

<style>
  .github-user {
    font-family: Verdana, "Lucida Sans Unicode", sans-serif;
  }
  .github-user--content {
    display: flex;
    align-items: center;
  }
  .github-user--content .github-user--avatar {
    margin: .25em 1.25em 0 0;
    border-radius: 100%;
    width: 4em;
    height: 4em;
    align-self: self-start;
  }
  .github-user--content .github-user--data {
    flex-grow: 1;
  }
  .github-user--content .github-user--data .name {
    margin: 0;
  }
  .github-user--content .github-user--data .html-url {
    color: #222;
  }
  .github-user--content .github-user--data .button {
    box-shadow: 1px 1px #4a4a4a;
    float: right;
    margin: 1em .25em .25em .5em;
    display: inline-block;
    text-decoration: none;
    background: var(--dm-green-dark, #1c7e35);
    color: #fff;
    padding: .5em 1em;
  }
</style>
